module.exports = __webpack_public_path__ + "static/media/lease2_img4.fd2c6235.jpg";